import { render, staticRenderFns } from "./ViewRequestModal.vue?vue&type=template&id=25039334&scoped=true"
import script from "./ViewRequestModal.vue?vue&type=script&lang=js"
export * from "./ViewRequestModal.vue?vue&type=script&lang=js"
import style0 from "./ViewRequestModal.vue?vue&type=style&index=0&id=25039334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25039334",
  null
  
)

export default component.exports